import { Outlet } from '@buzola/router'
import { ContemberClient } from '@contember/react-client'
import { IdentityProvider } from '@contember/react-identity'
import { adminConfig } from '~/entrypoint/config'

// Login scope: ContemberClient bound to the login token (the worker proxy
// swaps `__LOGIN_TOKEN__` for the real tenant login token on POST /_api/tenant).
export default function LoginLayout() {
	return (
		<ContemberClient apiBaseUrl={adminConfig.apiBaseUrl} loginToken={adminConfig.loginToken}>
			<IdentityProvider>
				<Outlet />
			</IdentityProvider>
		</ContemberClient>
	)
}
